export default class Plugin{
  editor = null
  constructor(){}
  install(editor){
    this.editor = editor
    this.init(editor)
  }
  init(editor){

  }
}